import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineRecordSchema, defineValidation } from "../../common/validation.common";
import { ProfitUnitEnum } from "../../data/enums";
import { RadiusProfileCommonSchema } from "../radius_profile/radius_profile.request";

export namespace ProductBroadbandValidation {
    export const Record = defineValidation(
        defineRecordSchema({
            filters: v.object({
                withTax: v.optional(v.boolean()),
                associateId: v.optional(v.string()),
            }),
        }),
    );

    export const SubscriptionRecord = defineValidation(BaseRecordSchema);

    export const Create = defineValidation(
        v.object({
            name: baseVals.string(),
            code: v.optional(baseVals.string()),
            price: baseVals.intMin(10_000, "Harga"),
            public: v.boolean(),
            withTax: v.boolean(),
            marketingProfit: v.variant("isActive", [
                v.object({
                    isActive: v.literal(true),
                    unit: v.picklist(ProfitUnitEnum.values, "Satuan Bagi Hasil wajib diisi."),
                    cost: v.number("Nilai Bagi Hasil wajib diisi."),
                }),
                v.object({
                    isActive: v.literal(false),
                }),
            ]),
            radiusProfile: RadiusProfileCommonSchema.create,
        }),
    );

    export const Update = defineValidation(
        v.object({
            name: v.exactOptional(baseVals.string()),
            code: v.exactOptional(baseVals.string()),
            price: v.exactOptional(baseVals.intMin(10_000, "Harga")),
            public: v.exactOptional(v.boolean()),
            withTax: v.exactOptional(v.boolean()),
            marketingProfit: v.exactOptional(
                v.variant("isActive", [
                    v.object({
                        isActive: v.literal(true),
                        unit: v.picklist(ProfitUnitEnum.values, "Satuan Bagi Hasil wajib diisi."),
                        cost: v.number("Nilai Bagi Hasil wajib diisi."),
                    }),
                    v.object({
                        isActive: v.literal(false),
                    }),
                ]),
            ),
            radiusProfile: v.exactOptional(RadiusProfileCommonSchema.create),
        }),
    );
}
